import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Setting, SettingListResponse, SettingQueryParams, SettingValue, UpdateSetting } from '@frontend/setting/types';

export class MySettingClient extends APIClient {
    public static readonly endpoint = '/setting-api/v1';

    public static async fetchMySettings(queryParams?: ApiQueryParams<SettingQueryParams>): Promise<SettingListResponse> {
        return await this.apiPaginated<SettingListResponse, SettingQueryParams>(`${this.endpoint}/my-settings`, queryParams);
    }

    public static async postMySetting(body: {value: SettingValue, key: string}): Promise<Setting> {
        const response = await this.post(`${this.endpoint}/my-settings`, body);
        return await this.handleResponse<Setting>(response);
    }

    public static async fetchMyAccountSettings(queryParams?: ApiQueryParams<SettingQueryParams>): Promise<SettingListResponse> {
        return await this.apiPaginated<SettingListResponse, SettingQueryParams>(`${this.endpoint}/my-account-settings`, queryParams);
    }

    public static async fetchMySetting(settingId: string): Promise<Setting> {
        const response = await this.fetch(`${this.endpoint}/my-settings/${settingId}`);
        return await this.handleResponse<Setting>(response);
    }

    public static async patchMySetting(settingId: string, body: UpdateSetting): Promise<Setting> {
        const response = await this.patch(`${this.endpoint}/my-settings/${settingId}`, body);
        return await this.handleResponse<Setting>(response);
    }

    public static async deleteMySetting(settingId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/my-settings/${settingId}`);
        await this.handleVoidResponse(response);
    }
}
